<template>
  <div
    class="form-group"
    :class="{ required: $required, error: $error }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    group: {
      type: Object,
      required: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    error: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    $required () {
      return (
        (this.group && this.group.$params.required) ||
        (!this.group && this.required)
      )
    },
    $error () {
      return (
        (this.group && this.group.$error) ||
        (!this.group && this.error)
      )
    }
  }
}
</script>
